var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallQualityDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_11702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#004DDD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_11702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.85 66C50.6 66 44.425 64.6375 38.325 61.9125C32.225 59.1875 26.675 55.325 21.675 50.325C16.675 45.325 12.8125 39.775 10.0875 33.675C7.3625 27.575 6 21.4 6 15.15C6 14.25 6.3 13.5 6.9 12.9C7.5 12.3 8.25 12 9.15 12H21.3C22 12 22.625 12.2375 23.175 12.7125C23.725 13.1875 24.05 13.75 24.15 14.4L26.1 24.9C26.2 25.7 26.175 26.375 26.025 26.925C25.875 27.475 25.6 27.95 25.2 28.35L17.925 35.7C18.925 37.55 20.1125 39.3375 21.4875 41.0625C22.8625 42.7875 24.375 44.45 26.025 46.05C27.575 47.6 29.2 49.0375 30.9 50.3625C32.6 51.6875 34.4 52.9 36.3 54L43.35 46.95C43.8 46.5 44.3875 46.1625 45.1125 45.9375C45.8375 45.7125 46.55 45.65 47.25 45.75L57.6 47.85C58.3 48.05 58.875 48.4125 59.325 48.9375C59.775 49.4625 60 50.05 60 50.7V62.85C60 63.75 59.7 64.5 59.1 65.1C58.5 65.7 57.75 66 56.85 66ZM15.15 30L20.1 25.05L18.75 18H12.15C12.4 20.05 12.75 22.075 13.2 24.075C13.65 26.075 14.3 28.05 15.15 30ZM42 56.715C43.95 57.555 45.9293 58.2468 47.9378 58.7903C49.9463 59.3338 51.967 59.687 54 59.85V53.25L46.95 51.75L42 56.715ZM15.15 30C14.3 28.05 13.65 26.075 13.2 24.075C12.75 22.075 12.4 20.05 12.15 18H18.75L20.1 25.05L15.15 30ZM42 56.7L46.95 51.75L54 53.25V59.85C51.95 59.7 49.925 59.35 47.925 58.8C45.925 58.25 43.95 57.55 42 56.7ZM51 36C46.85 36 43.3125 34.5375 40.3875 31.6125C37.4625 28.6875 36 25.15 36 21C36 16.85 37.4625 13.3125 40.3875 10.3875C43.3125 7.4625 46.85 6 51 6C55.15 6 58.6875 7.4625 61.6125 10.3875C64.5375 13.3125 66 16.85 66 21C66 25.15 64.5375 28.6875 61.6125 31.6125C58.6875 34.5375 55.15 36 51 36ZM49.5 30H52.5V18H49.5V30ZM51 15C51.4 15 51.75 14.85 52.05 14.55C52.35 14.25 52.5 13.9 52.5 13.5C52.5 13.1 52.35 12.75 52.05 12.45C51.75 12.15 51.4 12 51 12C50.6 12 50.25 12.15 49.95 12.45C49.65 12.75 49.5 13.1 49.5 13.5C49.5 13.9 49.65 14.25 49.95 14.55C50.25 14.85 50.6 15 51 15Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallQualityDark);
export default __webpack_public_path__ + "static/media/call_quality_dark.8546941c583a16088498813739b0d480.svg";
export { ForwardRef as ReactComponent };